import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cbs-form-layout',
  templateUrl: './form-layout.component.html',
  styleUrls: ['./form-layout.component.scss']
})
export class FormLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
